import React, { useContext, useEffect } from "react";
import { Alert } from "components/bootstrap";
import RenderCompletionCallback from "views/components/widgets/RenderCompletionCallback";
const WidgetVisualizationNotFound = ({ widgetClassName }) => {
  const onRenderComplete = useContext(RenderCompletionCallback);
  useEffect(() => onRenderComplete(), [onRenderComplete]);
  return /* @__PURE__ */ React.createElement(Alert, { bsStyle: "danger" }, "Widget Visualization (", /* @__PURE__ */ React.createElement("i", null, widgetClassName), ") not found. It looks like the plugin supplying this widget is not loaded.");
};
export default WidgetVisualizationNotFound;
